import React, { useCallback, useContext, useEffect } from "react";
import { CommonContext } from "hooks/CommonContext";
import { common } from "utils/constant";
import JoinHeader from "./JoinHeader";
import CandidateJoinPage from "./CandidateJoinPage";
import InterviewerJoinPage from "./InterviewerJoinPage";
import apiInterceptor from "services/apiInterceptor";
const { REACT_APP_CLOUD_FUNCTIONS_URL } = process.env;

/* Make .join-page-container fill the full viewport as a flex column
   so header is fixed height and the content below fills the rest. */
const STYLES = `
  .join-page-container {
    display: flex !important;
    flex-direction: column !important;
    height: 100vh !important;
    max-height: 100vh !important;
    overflow: hidden !important;
    background: #080d18 !important;
  }
`;

let _inj = false;
const inject = () => {
  if (_inj) return;
  const s = document.createElement("style");
  s.textContent = STYLES;
  document.head.appendChild(s);
  _inj = true;
};

const Index = () => {
  inject();

  const {
    socketRef,
    setUserName,
    userOwnData,
    room_id,
    aiAgentDetail,
    setIsInMeetingRoom,
    interviewDetails,
    typeOfInterview,
    startCameraAudio,
  } = useContext(CommonContext);

  const callSetInterviewStatus = useCallback(
    async (status = "I") => {
      try {
        const payload = {
          status,
          interview_guid: room_id,
          candidate_application_guid: userOwnData?.candidateApplicationGuid,
        };
        await apiInterceptor.post(
          `${REACT_APP_CLOUD_FUNCTIONS_URL}/interview_status_update`,
          payload
        );
      } catch (error) {
        console.error("Error updating interview status:", error);
      }
    },
    [room_id, userOwnData?.candidateApplicationGuid]
  );

  function joinRoomHandler() {
    setIsInMeetingRoom(true);
    if (socketRef.current) {
      socketRef.current.emit("join", {
        room_id: room_id,
        voiceName: aiAgentDetail?.voiceName,
        ...userOwnData,
      });
    }
    if (
      (!userOwnData.isCandidate && interviewDetails.status !== "I") ||
      interviewDetails?.interviewType === "AI"
    ) {
      callSetInterviewStatus();
    }
  }

  useEffect(() => {
    if (userOwnData.fname.length > 0) {
      setUserName(userOwnData.fname + " " + userOwnData.lname);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (typeOfInterview.length > 0 && userOwnData.isCandidate != null) {
      if (!(typeOfInterview === common.agent && userOwnData.isCandidate === false)) {
        startCameraAudio();
      }
    }
    // eslint-disable-next-line
  }, [typeOfInterview, userOwnData.isCandidate]);

  return (
    <div className="join-page-container">
      <JoinHeader />
      {userOwnData.isCandidate ? (
        <CandidateJoinPage joinRoomHandler={joinRoomHandler} />
      ) : (
        <InterviewerJoinPage joinRoomHandler={joinRoomHandler} />
      )}
    </div>
  );
};

export default Index;